<template>
    <div class="w-full h-full">
        <form @submit.prevent="submitForm" class="w-full h-full p-1 flex flex-col justify-between items-center pb-10" action="">
                <div class="grid grid-cols-3 gap-2 mb-4 w-full h-full">
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Post Date*</label>
                        <input type="date" required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="postData.post_date">
                    </div>
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Created By*</label>
                        <select required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="postData.created_by_id">
                            <option v-for="user in userOptions" :key="user.value" :value="user.value">{{ user.label }}</option>
                        </select>
                    </div>
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Post Type*</label>
                        <select required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="postData.post_type">
                            <option :value="null">------------</option>
                            <option value="Accounting">Accounting</option>
                            <option value="Contact">Contact</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div class="flex flex-col col-span-3">
                        <label class="tracking-widest text-gray-500" for="">Post Body</label>
                        <textarea required class="p-1 border mt-1 border-gray-400 rounded-md" rows="10" v-model="postData.post_body"></textarea>
                    </div>
                </div>
            <div class="flex w-full justify-center space-x-2">
                <base-button-affirmative>Save</base-button-affirmative>
                <base-button-negative @click.prevent="close">Cancel</base-button-negative>
            </div>
        </form>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, reactive } from 'vue';

const props = defineProps(['post', 'addOrEdit', 'userOptions', 'client'])

const emit = defineEmits(['close', 'addPost', 'editPost'])

const postData = reactive({
    post_date: props.post ? props.post.post_date : null,
    created_by_id: props.post ? props.post.created_by_id : null,
    post_body: props.post ? props.post.post_body : null,
    post_type: props.post ? props.post.post_type : null,
    client_id: props.client.id
})

function submitForm(){
    console.log('submit the form')
    if(props.addOrEdit == 'add'){
        emit('addPost', postData)
    }
    if(props.addOrEdit == 'edit'){
        emit('editPost', postData)
    }
}


function close(){
    emit('close')
}

</script>